import styled from 'styled-components';

import { Dialog } from 'components/dialog';
import { MultiSportSearchBar } from 'components/search/MultiSportSearchBar';
import { useIsLaptop } from 'hooks/device/useIsLaptop';

const StyledDialog = styled(Dialog)`
  top: 0;
  padding: var(--unit);
  margin: 0 auto auto auto;
`;

type Props = { onClose?: () => void };
export const SearchBarDialog = ({ onClose }: Props) => {
  const isLaptopAndAbove = useIsLaptop();

  return (
    <StyledDialog
      open
      onClose={onClose}
      fullScreen={!isLaptopAndAbove}
      maxWidth="xs"
      fullWidth
      hideHeader
    >
      <div className="forceSearchbarForDesktop">
        <MultiSportSearchBar
          onExit={false}
          onSelect={() => onClose?.()}
          onClose={onClose}
        />
      </div>
    </StyledDialog>
  );
};
